export default __webpack_public_path__ + "static/media/grafema_ummi_20.6201de69.jpg";